import styled from 'styled-components';

export const Title = styled.h3`
  font-weight: 400;
  margin: 0 0 10px;
  text-align: center;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  column-gap: 10px;
  margin: 4px 0;
`;

export const Label = styled.span`
  color: #999;
`;

export const Value = styled.span`
  flex: 1;
  text-align: end;
  overflow-wrap: break-word;
`;
